import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { OrderDetailsResponseBack } from '../../../models';
import { IOrderDetailsHttpService } from '../interfaces';

@Injectable()
export class OrderDetailsHttpService implements IOrderDetailsHttpService {
  constructor(protected httpClient: HttpClient) {}

  getOrderDetails(voucherCode: string, country: string): Promise<OrderDetailsResponseBack> {
    return firstValueFrom(this.httpClient.get<OrderDetailsResponseBack>(`/order-details/${voucherCode}`, { params: { country } }));
  }
}
